export const FIELD_TYPE_TEXT_LIST_LENGTH = 3
export const DEFAULT_COLOR = "#000000"
